import Button from 'modules/shared-components/button/button';
import { formatWithoutDecimals } from 'utils/FormatNumber';

interface PaginationProps {
  goToPage: (page: number) => void;
  activePage: {
    offset: number;
    limit: number;
    total: number;
  };
  title?: string;
}

export function Pagination({ goToPage, activePage, title }: PaginationProps) {
  const hasPreviousPage = activePage.offset > 0;
  const hasNextPage = activePage.total > activePage.offset + activePage.limit;
  const total = activePage.total;
  const item = Math.min(activePage.offset + activePage.limit, activePage.total);
  const page = activePage.offset / activePage.limit + 1;
  const lastPage = Math.ceil(activePage.total / activePage.limit);

  return (
    <div className="flex justify-between items-center">
      <div className="xxs:text-dex-white-secondary">
        {title ?? 'Item'}{' '}
        <span>
          {formatWithoutDecimals(activePage.offset ?? 0)}-
          {formatWithoutDecimals(item ?? 0)}
        </span>{' '}
        of <span>{formatWithoutDecimals(total ?? 0)}</span>
      </div>
      <div>
        <div className="space-x-1">
          <Button
            type="button"
            variant="dexNeutral"
            className="xxs:py-1 xxs:px-2"
            disabled={!hasPreviousPage}
            onClick={() => goToPage(1)}
          >
            <div className="xxs:text-xs">{'<<'}</div>
          </Button>
          <Button
            type="button"
            variant="dexNeutral"
            className="xxs:py-1 xxs:px-2"
            disabled={!hasPreviousPage}
            onClick={() => goToPage(page - 1)}
          >
            <div
              className="xxs:text-xs normal-case
"
            >
              Back
            </div>
          </Button>
          <Button
            type="button"
            variant="dexNeutral"
            className="xxs:py-1 xxs:px-2"
            disabled={!hasNextPage}
            onClick={() => goToPage(page + 1)}
          >
            <div
              className="xxs:text-xs normal-case
"
            >
              Next
            </div>
          </Button>
          <Button
            type="button"
            variant="dexNeutral"
            className="xxs:py-1 xxs:px-2"
            disabled={!hasNextPage}
            onClick={() => goToPage(lastPage)}
          >
            <div className="xxs:text-xs">{'>>'}</div>
          </Button>
        </div>
      </div>
    </div>
  );
}
